import {useId} from 'react'
import {SectionBlendGlow} from './SectionBlendGlow'

export type SectionBlendDirection = 'above' | 'below'

export type SectionBlendUIProps = {
  blendDirection: SectionBlendDirection
}

export const SectionBlend = ({blendDirection}: SectionBlendUIProps) => {
  const uid = useId().replace(/:/g, '')

  return (
    <div aria-hidden="true" className="relative h-0 w-full">
      <div className="absolute inset-x-0 top-0 h-24 -translate-y-1/2 backdrop-blur-2xl [-webkit-mask-image:linear-gradient(to_bottom,transparent,black_50%,transparent)] [mask-image:linear-gradient(to_bottom,transparent,black_50%,transparent)]" />
      {blendDirection === 'above' ? (
        <div className="absolute inset-x-0 bottom-0 top-[-128px] h-[144px] overflow-hidden md:top-[-172px] md:h-[234px] lg:top-[-238px] lg:h-[304px]">
          <div className="absolute inset-x-0 bottom-0 h-[144px] md:h-[234px]">
            <SectionBlendGlow className="size-full" uid={`section-blend-${uid}`} />
          </div>
        </div>
      ) : (
        <div className="absolute inset-x-0 top-[-36px] h-[144px] overflow-hidden md:h-[234px]">
          <div className="absolute inset-x-0 top-0 h-[144px] scale-y-[-1] md:h-[234px]">
            <SectionBlendGlow className="size-full" uid={`section-blend-${uid}`} />
          </div>
        </div>
      )}
    </div>
  )
}
